import React from 'react';
import './OperationItem.scss'

const OperationItem = (props ) => {
    const selectedClass = props.isChecked ? 'selected' : ''
    // console.log("allooo",typeof(scrollToNext));
    const handleItemClick = () => {
        props.handlClick() 
        if (!props.isChecked){
            props.scrollToNext()
        }
    }
    return (
        <li tabIndex='0' role="button" key={props.id} className={`operation-item ${selectedClass}`} onClick={handleItemClick}  
            onKeyDown = {(e)=> e.key === 'Enter' && props.handlClick()}>
            <div className="operation-item__wrapper">
                <i className={`operation-icon ${selectedClass}`} style={{ backgroundImage: `url(${props.icon})` }}  ></i>
                <label className="operation-title" for={`operation`+props.id}>
                    {props.title}
                </label>
                <input type='checkbox' checked={props.isChecked} readOnly id={`operation`+props.id} name={`operation`+props.id} />
            </div>
        </li>
    );

}
export default OperationItem;